import Select from "react-select";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { getGroupState } from "state/slices/group-slice";
import "react-bootstrap-typeahead/css/Typeahead.css";
import useDeviceDimensions from "hooks/useDeviceDimensions";
import {
  clearHomePageEventIdFilter,
  setHomePageEventIdFilter,
} from "state/slices/user-settings-slice";

const HomepageEventFilter = ({ uniqueEvents, eventFilter }: any) => {
  const { isMobile } = useDeviceDimensions();
  const groupId = useAppSelector(getGroupState).id;
  const dispatch = useAppDispatch();
  return (
      <div
          style={{
              paddingLeft: 12,
              paddingRight: 12,
              paddingTop: 10,
              paddingBottom: 5,
              width: "100%",
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "center",
          }}
      >
      <Select
          styles={{
              container: (base) => ({ ...base, width: "100%" }),
              control: (base) => ({ ...base, borderRadius: 5 }),
          }}
        isClearable
        placeholder={"Filter by event"}
        options={Array.from(uniqueEvents).map((event: any) => ({
          value: event.id,
          label: event.name,
        }))}
        value={
          eventFilter
            ? { value: eventFilter?.id, label: eventFilter?.name }
            : null
        }
        onChange={(selectedEvent) => {
          if (selectedEvent == null) {
            dispatch(clearHomePageEventIdFilter({ groupId: groupId }));
          } else {
            dispatch(
              setHomePageEventIdFilter({
                groupId: groupId,
                eventId: selectedEvent.value,
              })
            );
          }
        }}
      />
    </div>
  );
};

export default HomepageEventFilter;
